import { getPlans } from "../apis/workspace/billing";
import { useStoreBilling } from "../stores/useStoreBIlling";
import { useSmartQuery } from "./useSmartQuery";

export const useBilling = (workspaceId) => {
  const { plans, setPlans } = useStoreBilling();

  const shouldFetch = !!workspaceId;

  const query = useSmartQuery(
    ["get_billing_plans", workspaceId],
    () =>
      getPlans({
        options: { headers: { "X-Workspace-Id": workspaceId } },
      }),
    {
      condition: shouldFetch, // ✅ No need to return early
      zustandSetter: setPlans,
    }
  );

  return {
    plans,
    ...query,
  };
};
